import common from './common';
import dashboard from './dashboard';
import accountInfo from './accountInfo';
import accountDetails from './accountDetails';
import einDashboard from './einDashboard';
import branches from './branches';
import company from './company';
import nps from './nps';
import einProgram from './einProgram';
import users from './users';
import apiAccess from './apiAccess';
import preferences from './preferences';
import thirdParty from './thirdParty';
import serviceAreas from './serviceAreas';
import header from './header';
import footer from './footer';
import adminPanel from './adminPanel';
import merchandiseCredit from './merchandiseCredit';
import leadPreferences from './leadPreferences';
import gridProfile from './gridProfile';
import registration from './registration';
import authorizedDealer from './authorizedDealer';
import dataPlanExtension from './dataPlanExtension';
import deviceReplacement from './deviceReplacement';

const de = {
  ...common,
  ...dashboard,
  ...accountInfo,
  ...accountDetails,
  ...einDashboard,
  ...branches,
  ...company,
  ...nps,
  ...einProgram,
  ...users,
  ...apiAccess,
  ...preferences,
  ...thirdParty,
  ...serviceAreas,
  ...header,
  ...footer,
  ...adminPanel,
  ...merchandiseCredit,
  ...leadPreferences,
  ...gridProfile,
  ...registration,
  ...authorizedDealer,
  ...dataPlanExtension,
  ...deviceReplacement
};

export default de;
